/** Loads a fresh HiGHS WebAssembly module with the given options. */
export async function loadHiGHSModule(options) {
    const createModule = await loadHiGHSFactory();
    const consoleConfig = options?.console ?? { log: null, error: null };
    const moduleOptions = {
        print: consoleConfig.log ?? (() => { }),
        printErr: consoleConfig.error ?? (() => { }),
    };
    return createModule(moduleOptions);
}
async function loadHiGHSFactory() {
    const { default: HiGHSModuleFactory } = await import(new URL('../build/highs.js', import.meta.url).href);
    return HiGHSModuleFactory;
}
//# sourceMappingURL=module.js.map